import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { PropertyExportCommandHandler } from './property-export-command-handler.service';
import { propertyCommand } from '../../command/property.command';
import { MoveToCompanyCommandHandler } from './move-to-company-command-handler.service';
import { PropertyTaxRentalCommandHandler } from './property-tax-rental-command-handler.service';

@Injectable()
export class PropertyCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    exportHandler: PropertyExportCommandHandler,
    moveToCompanyHandler: MoveToCompanyCommandHandler,
    propertyTaxRentalHandler: PropertyTaxRentalCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(propertyCommand.export, exportHandler);
    this.addHandler(propertyCommand.moveToCompany, moveToCompanyHandler);
    this.addHandler(propertyCommand.propertyTaxRental, propertyTaxRentalHandler);
  }
}
